export const isAuthenticated = () => {
    var record = JSON.parse(localStorage.getItem("key"));
    if (!record){
        return false;
    }else{
        var token = record.token;
        if (new Date().getTime() > record.timestamp || !token) {
            localStorage.clear();
            return false;
        }else{
            return token && token.length > 10;
        }
    }
}